<script setup lang="ts">
import ImportSalesTaxUploader from './sales-tax/ImportSalesTaxUploader.vue'

defineOptions({
  name: 'ToolsImportSalesTaxPage',
})
</script>

<template>
  <ImportSalesTaxUploader />
</template>
